import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

/** 右ペインの開閉アニメーション (0.2s) より少し長く待つ */
const RESIZE_DELAY_MS = 220;

type Props = {
  /** これが変わったらサイズを取り直す。右ペインの開閉状態を渡す想定 */
  watch: unknown;
};

/**
 * MapContainer の子として置く不可視コンポーネント。
 *
 * Leaflet はコンテナのサイズをマウント時に測って保持する。右ペインを閉じて地図が
 * 広がっても invalidateSize を呼ばないと、広がった分がタイルの無い空白になる。
 *
 * Why 遅延: 開閉には 0.2s の transition がある。終わる前に測ると古い幅を拾うので、
 * アニメーションの完了を待ってから測る。
 */
const MapInvalidateSize = ({ watch }: Props) => {
  const map = useMap();
  const previous = useRef(watch);

  useEffect(() => {
    if (previous.current === watch) return;
    previous.current = watch;

    const timer = setTimeout(() => map.invalidateSize(), RESIZE_DELAY_MS);
    return () => clearTimeout(timer);
  }, [map, watch]);

  return null;
};

export default MapInvalidateSize;
